<template>
  <v-container>
    <v-layout row wrap>
    </v-layout>
        <iframe :src="src" ref="pdf" target="_blank" pagelayout="landscape" frameborder="0" style="overflow:hidden;overflow-x:hidden;overflow-y:hidden;height:100%;width:100%;position:absolute;top:0px;left:0px;right:0px;bottom:0px" height="100%" width="100%" > 
        </iframe>
  </v-container>
</template>

<script>
/* eslint-disable */
//import jsPDF from "jspdf";
import { mapActions } from "vuex";
import pdf from "vue-pdf";
import moment, { months } from 'moment';
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import SettingService from "@/services/SettingService";
import DocumentService from "@/services/DocumentService";
export default {
  components: {
    pdf
  },
  data() {
    return {
        earning:0,
        tax_pay:0,
        names:"",
        dates :"",
        src: "",
        json: {},
        newjson: {},
        jsonData : [],
        indexs:"",
        cumulativeSSs:"",
        last_salarys:"",
        totalsalary :0,
        totalss:0,     
        totaltext:[]  ,
        tmpResult: {},
        taxpayer_number:"",
    };
  },
  created() {
    this.branch = this.$route.params.branch;
    this.from_date = this.$route.params.fromDate;
    this.to_date = this.$route.params.toDate;
   this.getCompany();
  
    
  },
  methods: {
     goto(path) {
      this.$router.push("/" + path);
    },
    
     groupBy(array, key) {
      const result = {};
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    process() {
      let v = this;
       let branchs = "";
      if(this.branch == "ALL"){
        branchs = "";
         DocumentService.getTaxDetailByMonths(branchs,this.dep,this.from_date,this.to_date)
        .then(res => {
          console.log(res);
          this.json = res.data;
          this.tabledata = true;
          console.log("this.json: ", this.json);
          //**new array **//
          this.newjson.from_date = this.json.from_date;
          this.newjson.to_date = this.json.to_date;
          this.newjson.total_earning = this.json.total_earning;
          this.newjson.total_tax = this.json.total_tax;
          this.newjson.details = [];
          var sumearning = 0;
          var sumtax_pay = 0;
          this.newjson.details = [];
          const unique = this.groupBy(this.json.details, "emp_code");
         // console.log(unique);
          let keys = "";
          let index = 0;
          for (var key in unique) {
            console.log("key: ", key);
            let emp_code = "";
            let id_card = "";
            let emp_name = "";
            let payDate = "";
            let address = "";
            let j = 0;
            sumearning = 0;
            sumtax_pay = 0;
            unique[key].forEach(element => {
              if (j == 0) {
                //values += element.packaging_name;
              } else if (j != 0) {
                //values += "/" + element.packaging_name;
              }
              emp_code = element.emp_code;
              id_card = element.id_card;
              emp_name = element.emp_name;
              payDate = element.payDate;
              address = element.address;
              sumearning += element.earning;
              sumtax_pay += element.tax_pay;
              j++;
            });
            this.newjson.details.push({
              emp_code: emp_code,
              id_card: id_card,
              emp_name: emp_name,
              payDate: payDate,
              address: address,
              earning: sumearning,
              tax_pay: sumtax_pay
            });
          }
          // console.log("json: ", this.json);
          // console.log("new json: ", this.newjson);
         this.getPDFByYear();
        })
        .catch(err => {
          console.log(err);
          
        });
      }else{
        branchs = this.branch;
         DocumentService.getTaxDetailByMonths(branchs,this.dep,this.from_date,this.to_date)
        .then(res => {
          console.log(res);
          this.json = res.data;
          this.tabledata = true;
          console.log("this.json: ", this.json);
          //**new array **//
          this.newjson.from_date = this.json.from_date;
          this.newjson.to_date = this.json.to_date;
          this.newjson.total_earning = this.json.total_earning;
          this.newjson.total_tax = this.json.total_tax;
          this.newjson.details = [];
          var sumearning = 0;
          var sumtax_pay = 0;
          this.newjson.details = [];
          const unique = this.groupBy(this.json.details, "emp_code");
          console.log(unique);
          let keys = "";
          let index = 0;
          for (var key in unique) {
            console.log("key: ", key);
            let emp_code = "";
            let id_card = "";
            let emp_name = "";
            let payDate = "";
            let address = "";
            let j = 0;
            sumearning = 0;
            sumtax_pay = 0;
            unique[key].forEach(element => {
              if (j == 0) {
                //values += element.packaging_name;
              } else if (j != 0) {
                //values += "/" + element.packaging_name;
              }
              emp_code = element.emp_code;
              id_card = element.id_card;
              emp_name = element.emp_name;
              payDate = element.payDate;
              address = element.address;
              sumearning += element.earning;
              sumtax_pay += element.tax_pay;
              j++;
            });
            this.newjson.details.push({
              emp_code: emp_code,
              id_card: id_card,
              emp_name: emp_name,
              payDate: payDate,
              address: address,
              earning: sumearning,
              tax_pay: sumtax_pay
            });
          }
          // console.log("json: ", this.json);
          // console.log("new json: ", this.newjson);
         this.getPDFByYear();
        })
        .catch(err => {
          console.log(err);
          
        });
      }
     
      
    },
    async getPDFByYear() {
        let v = this;
      NProgress.start();
      try {
        let tmpResult = this.newjson;
        // gen items
        let rowIndex = 0;
        let index =0;
        let i = 0;
          console.log(tmpResult.data)
        tmpResult.details.forEach(element => {
      
          rowIndex++;
              v.name = element.emp_name.split('(')[0] ;//ชื่อพนักงาน
              if(element.id_card != null){
                v.IDcard = v.IDcardformat(element.id_card);//บัตรประชาชน
              }else{
                 v.IDcard = " ";
              }
              if(element.earning != null){
                 v.earning = v.thousandSep(element.earning);//เงินเดือน
              }else{
                v.earning = v.thousandSep(0);
              }
              if(element.tax_pay != null){
                v.tax_pay = v.thousandSep(element.tax_pay);//ภาษี
              }else{
                v.tax_pay =v.thousandSep(0);
              }
              v.date = moment(element.payDate).format('DD/MM/YYYY');
             
              v.salary =  element.earning;
              v.ss = element.tax_pay; 
              v.add = element.address;
              // console.log("name",v.name);
              // console.log("totalDeduct",element.totalDeduct);
              // console.log("total_balance",element.total_balance);
              
          if(element.totalEarning != 0 ){
            if(element.tax_pay != 0){
         
              v.ind = (i+1)+`\n\n\n`;
              v.names += v.IDcard+`\n`+v.name+`\n\n`;
              v.dates += v.date+`\n\n\n`;
              v.last_salarys += v.earning+`\n\n\n`;
              v.cumulativeSSs += v.tax_pay +`\n\n\n`;
              v.indexs += v.ind;
              v.totalsalary += v.salary;
              v.totalss += v.ss;
              index++;
              i++;
              v.page++;
            }
          
          }
          console.log(index);
          console.log(tmpResult.details.length);
     
          if(index == 8 ){
             v.jsonData.push(v.genSlipJson("after"));
              v.names = "";
              v.dates="";
              v.last_salarys =""
              v.cumulativeSSs = ""
              v.indexs = "";
            
              index=0;
          }
          else if(i == tmpResult.details.length){
            v.jsonData.push(v.genSlipJson(""));
          }

          
        });
         
        this.createpdf();
      } catch (err) {
        console.log(err);
      }
      NProgress.done();
    },
    thousandSep(nStr) {
      nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    IDcardformat(value) {
      var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
      var matches = v.match(/\d{1,13}/g);
      var match = matches && matches[0] || ''
      var parts = []

         parts.push(match.substring(0,1))
         parts.push(match.substring(1,5))
         parts.push(match.substring(5,10))
         parts.push(match.substring(10,12))
         parts.push(match.substring(12,13))
    

    if (parts.length) {
        return parts.join('-')
    } else {
        return value
    }
    },
    async getCompany() {
      let v = this;
      try {
        this.tmpResult = await SettingService.getDataCompany();
        v.taxpayer_number = this.tmpResult.data.content[0].taxpayer_number;
        this.process();
      } catch (err) {
        console.log(err);
      }
    },
    createpdf() {
      let v = this;
      var pdfMake = require("pdfmake/build/pdfmake.js");
      //pdfMake.setFonts(fonts);
      pdfMake.fonts = {
        Sarabun: {
          normal:
            "https://fonts.gstatic.com/s/sarabun/v12/DtVjJx26TKEr37c9WBJDnlQN9gk.ttf",
          bold: "https://fonts.gstatic.com/s/sarabun/v12/DtVmJx26TKEr37c9YK5sulwm6gDXvwE.ttf",
          italics:
            "https://fonts.gstatic.com/s/sarabun/v12/DtVhJx26TKEr37c9aBBJmnYI5gnOpg.ttf",
          bolditalics:
            "https://fonts.gstatic.com/s/sarabun/v12/DtVkJx26TKEr37c9aBBxJlks7iLSrwFUlw.ttf",
        },
      };
      // if (pdfMake.vfs == undefined) {
      //   var pdfFonts = require("pdfmake/build/vfs_fonts.js");
      //   pdfMake.vfs = pdfFonts.pdfMake.vfs;
      // }

      // // pdfMake.fonts = {
      // //   THSarabunNew: {
      // //     normal: "THSarabunNew.ttf",
      // //     bold: "THSarabunNew-Bold.ttf",
      // //     italics: "THSarabunNew-Italic.ttf",
      // //     bolditalics: "THSarabunNew-BoldItalic.ttf"
      // //   },
      // //   Roboto: {
      // //     normal: "Roboto-Regular.ttf",
      // //     bold: "Roboto-Medium.ttf",
      // //     italics: "Roboto-Italic.ttf",
      // //     bolditalics: "Roboto-MediumItalic.ttf"
      // //   }
      // // };

      console.log(this.jsonData);
      let docDefinition = {
        content: this.jsonData,
        pageOrientation: 'landscape',
        styles: {
          header: {
            fontSize: 14,
            bold: true,
            margin: [0, 0, 0, 3]
          },
          subheader: {
            fontSize: 13,
            bold: false
          },
          detailtext: {
            fontSize: 12,
            bold: false
          },
           subtext: {
            fontSize: 12,
            bold: false
          }
        },
        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
        }
      };

      this.pdfDocGen = pdfMake.createPdf(docDefinition);

      this.pdfDocGen.getDataUrl(data => {
        this.src = data;
      });
    },
    genSlipJson(param) {
   //console.log(this.names)
      let jSonResult = [
           {
          columns: [   
           
            {
              text: "ใบแนบ ภ.ง.ด.1",
              style: "header",
              alignment: "left",
             
            },
             {
              text: "เลขประจำตัวผู้เสียภาษีอากร (ของผู้มีหน้าที่หักภาษี ณ ที่จ่าย) ",
              style: "subheader",
              alignment: "right",
            },
            {
             
              width: 35,
              margin: [25,0,0,0],
              table: {
                widths: [5],
                heights: [5],
                headerRows: 1,
                body: [
                  [
                    { text: this.taxpayer_number.substring(0, 1)},
                  ],
                ]
              }, 
            },
             {
              text: "-",
              style: "subheader",
              alignment: "right",
              width: 15,
              margin: [5,0,0,0],
            },
             {
             
              width: 55,
              margin: [5,0,0,0],
              table: {
                widths: [5,5,5,5],
                heights: [10,10,10,10],
                headerRows: 1,
                body: [
                  [
                    { text: this.taxpayer_number.substring(1,2) },
                    { text:this.taxpayer_number.substring(2,3) },
                    { text: this.taxpayer_number.substring(3,4) },
                    { text: this.taxpayer_number.substring(4,5) },
                  ],
                ]
              }, 
            },
            {
              text: "-",
              style: "subheader",
              alignment: "right",
              width: 15,
              margin: [5, 0, 0, 0],
            },
            {
               width: 70,
               margin: [5,0,0,0],
              table: {
                widths: [5,5,5,5,5],
                heights: [10,10,10,10,10],
                headerRows: 1,
                body: [
                  [
                    { text: this.taxpayer_number.substring(5,6) },
                    { text: this.taxpayer_number.substring(6,7) },
                    { text: this.taxpayer_number.substring(7,8) },
                    { text: this.taxpayer_number.substring(8,9) },
                    { text: this.taxpayer_number.substring(9,10) }
                  ],
                ]
              }, 
            },
            {
              text: "-",
              style: "subheader",
              alignment: "right",
              width: 15,
              margin: [5,0,0,0],
            },
            {
              width: 27,
              margin: [5,0,0,0],
              table: {
                widths: [5,5],
                heights: [10,10],
                headerRows: 1,
                body: [
                  [
                    { text: this.taxpayer_number.substring(10,11) },
                    { text: this.taxpayer_number.substring(11,12) }
                  ],
                ]
              }, 
            },
             {
              text: "-",
              style: "subheader",
              alignment: "right",
              width: 15,
              margin: [5,0,0,0],
            },
                        {
               width: 10,
               margin: [5,0,0,0],
              table: {
                widths: [5],
                heights: [10],
                headerRows: 1,
                body: [
                  [
                    { text: this.taxpayer_number.substring(12,13) }
                  ],
                ]
              }, 
            },
          ]
        },

        {
          columns: [
           {
              width:680,
              text: "ลำดับที่สาขา",
              style: "subheader",
              alignment: "right",
               margin: [5, 0, 5, 5],
            },
            {
              style: "text",
              alignment: "right",
               width: 150,
                margin: [7, 0, 5, 5],
              table: {
                widths: [5,5,5,5,5,5],
                heights: [10,10,10,10,10,10],
                headerRows: 1,
                body: [
                  [
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    { text: "" }
                  ],
                ]
              },
               
            },
          ]
        },
        
        {
          columns: [
            {
              
          
              style: 'tableExample',
              table: {
                widths: [50,386,90,100,100],
                headerRows: 1,
                body: [
                  [
                    
                    { text: "ลำดับที่",alignment: "center", style: "subtext", },
                    { text: "เลขประจำตัวผู้เสียภาษีอากร(13 หลัก) (ของผู้มีเงินได้)"+"\n"+"ชื่อผู้มีเงินได้(ให้ระบุให้ชัดเจนว่าเป็น นาย นาง นางสาว หรือยศ)",alignment: "center", style: "subtext", },
                    { text: "วัน เดือน ปี ที่จ่าย",alignment: "center", style: "subtext", },
                    { text: "จำนวนเงินได้"+"\n"+"ที่จ่ายในครั้งนี้ ",alignment: "center", style: "subtext", },
                    { text: "จำนวนเงินภาษีที่"+"\n"+"หักและนำส่งในครั้งนี้",alignment: "center", style: "subtext", }
                  ],
                  [
                    { text: this.indexs,alignment: "center", style: "detailtext", },
                    { text: this.names,alignment: "left", style: "detailtext", margin: [10, 0, 0, 0]},
                    { text: this.dates,alignment: "center", style: "detailtext", },
                    { text: this.last_salarys,alignment: "center", style: "detailtext", },
                    { text: this.cumulativeSSs,alignment: "center", style: "detailtext", }
                  ],
                
                ]
              },
              
            },
          
          ]
        },
         {
          columns: [
            {
               width: 553,
              text: "รวมยอดเงินได้และภาษีที่นำส่ง (นำ ไปรวมกับใบแนบ ภ.ง.ด.1ก แผ่นอื่น (ถ้ามี))",
                margin: [7, 5, 5, 5],
              style: "subheader",
              alignment: "right",
            },
            { 
             style: "text",
              alignment: "right",
             
              table: {
                widths: [100,100],
                headerRows: 1,
                body: [
                  [
                    { text: this.thousandSep(parseFloat(this.newjson.total_earning)),alignment: "center", style: "subheader", },
                    { text: this.thousandSep(parseFloat(this.newjson.total_tax)),alignment: "center", style: "subheader",}
                  ],
                   [
                    { text: "",alignment: "center", style: "subheader", },
                    { text: "",alignment: "center", style: "subheader",}
                  ],
                ]
              },
               
            },
          ]
        },
     
        {
          columns: [
            {
              width: 576,
              text: "",
              style: "subheader",
              alignment: "left",
              pageBreak: param
            },
          ]
        }
      ];
      return jSonResult;
    }
  },
};
</script>

<style lang="stylus" scoped>
.print {
  width: 100%;
  height :100%;


  table {
    width: 100%;
    border-bottom: 1px solid #F2F2F2;
  }

  table th {
    border-bottom: 1px solid #F2F2F2;
  }
}
</style>
